// Saving a file the app made or downloaded (exports, invoices, bot files, recovery codes).
// A browser downloads it; the app writes it to its cache and opens the share sheet,
// where the person saves it to Files, sends it or opens it in another app.
import { Directory, Filesystem } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import { isNative } from './platform';

const toBase64 = (blob) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(String(reader.result).split(',')[1] || '');
  reader.onerror = () => reject(reader.error);
  reader.readAsDataURL(blob);
});

export async function saveFile(blob, filename) {
  if (!isNative()) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    return;
  }
  const safe = (filename || 'download').replace(/[/\\]/g, '_');
  const { uri } = await Filesystem.writeFile({
    path: safe, data: await toBase64(blob), directory: Directory.Cache,
  });
  await Share.share({ title: safe, files: [uri] });
}
